module.exports = __webpack_public_path__ + "static/media/heatPumpIcon.024f3a83.svg";